import { useEffect, useState } from 'react';
import { isXSmallResolution } from '@philips-internal/oswald-ui-utils';
function useIsXSmallResolution() {
    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(isXSmallResolution());
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return isMobile;
}
export { useIsXSmallResolution, };
//# sourceMappingURL=use-is-xsmall-resolution.js.map